import { useEffect } from "react";
import { useTour } from "../../routes/JoyrideProvide";

/* istanbul ignore next */
export const useLoginEffects = (userData) => {
  const { startTour } = useTour();

  useEffect(() => {
    const hideTour = localStorage.getItem("hideTour") === "true";

    if (userData?.isWalkMeEnabled && !hideTour) {
      startTour();
    }
  }, [userData, startTour]);

  useEffect(() => {
    const shouldAnimate = sessionStorage.getItem("showLoginAnimation");
    if (shouldAnimate !== "true") return;

    const observer = new MutationObserver(() => {
      const element = document.querySelector(".rocket-wrapper");

      if (element) {
        element.classList.add("animate-blue");

        element.addEventListener(
          "animationend",
          () => {
            element.classList.remove("animate-blue");
          },
          { once: true }
        );

        sessionStorage.removeItem("showLoginAnimation");
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);
};